module.exports = __webpack_public_path__ + "media/images/icons/down_caret-fd35ff6df4a97a4375227da204878d23.svg";